import styled from 'styled-components';
import { Checkbox } from '@rsos/base-components';
import { DropdownDialog } from '@rsos/base-components/Dropdown/DropdownComponents';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const FilterCheckbox = styled(Checkbox)`
  padding: 8px 16px 8px 12px;
`;

export const CallQueueFilterDropdownDialog = styled(DropdownDialog).attrs(
  ({ isCollapsed }) => {
    return {
      top: isCollapsed ? '25%' : 30,
      left: isCollapsed ? 62 : -75,
    };
  },
)`
  ${({ isCollapsed }) => isCollapsed && `transform: translateY(-50%);`}
  ${({ theme }) =>
    `border: 1px solid ${theme.colors.palette.heavy_line_outline};`}
  @media (max-width: ${BP_LAPTOP}px) {
    left: -131px;
  }
`;
